import { defineStore } from 'pinia'


export const useNotificationStore = defineStore('notifications', {
    state: () => ({
        notifications: [] as Array<INotification>,
    }),
    actions: {
        newNotification(notification: INotification) {
            if (!notification.by_user) {
                notification.by_user = useUserStore().name
            }
            this.notifications.push(notification)
        }
    },
})
